module.exports = __webpack_public_path__ + "media/images/pc/stores/omiya/omiya_concept_03-c6dd190fb1de538ce6177ba676fd19c5.jpg";